export default function PageNotFound() {
    return (
        <h1>404 Error! Page Not found</h1>
    )
}